import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Slack Send Message v2 Configuration Validator
 * Validates Slack message configuration including connection, channel, and content
 */
export const Slack_Send_Channel_Message_2_ConfigValidator = z
    .object({
    slackConnection: requiredString('Slack Connection is required'),
    message: requiredString('Message is required'),
    channel: z.string().optional(),
    customChannel: z.string().optional()
})
    .refine((data) => {
    return data.channel || data.customChannel;
}, {
    path: ['channel', 'customChannel'],
    error: 'Channel or Custom Channel is required'
});
//# sourceMappingURL=slack-send-channel-message-2.js.map